export { resource } from './resource';
export { Img } from './img';
